export default "__VITE_ASSET__0E0fT6Qy__"